// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"gXyfVn15p4xt"};